import React from 'react';
import PropTypes from 'prop-types';

import {CircularProgress, Typography} from 'views/components';
import {translate} from 'views/module';

import RecordingPlayer from './RecordingPlayer';
import useInvitationRecordings from './useInvitationRecordings';

const STRINGS = 'career.jobDetail.Invitations.Recording';

// The full recording of a completed job interview, for staff only. Only the call that completed the
// interview has a recording.
const InvitationInterviewRecording = (props) => {
  const {invitation, label} = props;

  const hasRecording = (invitation.calls || []).some((call) => call.recordingKey);
  const {recordings, loading, error, refresh} = useInvitationRecordings(invitation.id, hasRecording);

  const getLink = React.useCallback(async () => (await refresh())?.interview || null, [refresh]);

  if (loading) {
    return <CircularProgress size={20} />;
  }

  if (error) {
    return (
      <Typography sx={{fontSize: '12px', color: 'error.main'}}>
        {translate(`${STRINGS}.LoadError`)}
      </Typography>
    );
  }

  if (!recordings?.interview) {
    return (
      <Typography sx={{fontSize: '12px', color: '#6B6760'}}>
        {translate(`${STRINGS}.NoRecording`)}
      </Typography>
    );
  }

  return (
    <RecordingPlayer
      link={recordings.interview}
      getLink={getLink}
      label={label}
    />
  );
};
InvitationInterviewRecording.propTypes = {
  invitation: PropTypes.shape({
    id: PropTypes.string.isRequired,
    calls: PropTypes.array,
  }).isRequired,
  label: PropTypes.string.isRequired,
};

export default React.memo(InvitationInterviewRecording);
